class Resource {
  constructor(data) {
    if (!data) {
      data = {}
    }

    this.data = data

    // return new Proxy(this, {
    //   get: function (resource, field, receiver) {

    //     if (!Reflect.has(...arguments)) {
    //       return;
    //     }

    //     resource.data = data

    //     let value = Reflect.get(...arguments);

    // Idea: Object.keys(obj).length === 0 && obj.constructor === Object

    //     if (typeof value === 'object') {
    //       return value;
    //     } else if (typeof value === 'function' && field == 'toJson') {
    //       return Reflect.get(...arguments)
    //     } else {
    //       return resource[field]()
    //     }
    //   },
    //   set: function (resource, field, value) {
    //     resource.data = data
    //     return resource[field](value);
    //   }
    // }
    // );
  }

  owner(owner) {
    if (!this.data._owners[owner]) {
      return ''
    }
    return this.data._owners[owner]
  }

  toTrimmedObject() {
    return this.toObject(true)
  }

  toObject(trim = false) {
    let data = JSON.parse(JSON.stringify(this.data))

    if (trim) {
      if (data.identifiers) {
        delete data.identifiers
      }

      if (data.security && data.security.public_token != undefined) {
        delete data.security.public_token
      }

      if (data.security && data.security.must_change_password != undefined) {
        delete data.security.must_change_password
      }

      if (data.security && data.security.roles != undefined) {
        delete data.security.roles
      }
    }

    return this.clearEmpties(data) // Alternative: data = { ...user.toObject() }
  }

  toJson() {
    return JSON.stringify(this.data)
  }

  clearEmpties(o) {
    for (var k in o) {

      // Delete null or undefined values, keep false values
      if (o[k] === null || o[k] === undefined) {
        delete o[k]
        continue
      }

      // Recurse into object and check again
      if (typeof o[k] == "object" && Object.keys(o[k]).length > 0) {
        this.clearEmpties(o[k])
      }

      // Delete empty objects
      if (typeof o[k] == "object" && Object.keys(o[k]).length === 0) {
        delete o[k]
      }
    }

    return o;
  }
}

export default Resource
